import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authContext } from "../Context/AuthContext";
import "../Styles/LoginStyle.css";
import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, Col, Form, FormFeedback, FormGroup, Input, Row, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Eye, EyeOff } from 'lucide-react';
import Logo from '../Assets/logo.png';
import { Api } from "../Services/CohortServices";

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonForgotPassword, setButtonForgotPassword] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const navigate = useNavigate();
  const auth = useContext(authContext);

  const validateForm = () => {
    let valid = true;

    if (!email) {
      setEmailError('Por favor, insira seu email.');
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setEmailError('Por favor, insira um email válido.');
      valid = false;
    } else {
      setEmailError('');
    }

    if (!password) {
      setPasswordError('Por favor, insira sua senha.');
      valid = false;
    } else {
      setPasswordError('');
    }

    return valid;
  };

  const handleLogin = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      try {
        let isLogged = await auth.signIn(email, password);
        if (isLogged) {
          navigate('/dashboard');
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        alert('Erro ao tentar fazer login. Tente novamente.');
      }
    }
  };

  const handleClear = () => {
    setEmail('');
    setPassword('');
    setEmailError('');
    setPasswordError('');
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      alert('Por favor, insira seu email.');
      return;
    }

    try {
      setButtonForgotPassword(true);
      const response = await Api.post('/forgot-password', { email: forgotEmail });
      if (response.status !== 200) {
        throw new Error();
      } else {

        alert(`Uma nova senha foi enviada para: ${forgotEmail}`);
        setForgotEmail('');
      }
    }
    catch (error) {
      alert('Erro ao tentar recuperar senha. Tente novamente.');
    }
    finally {
      setButtonForgotPassword(false);
      setForgotEmail('');
      setForgotPasswordModal(false);
    }
  };

  return (
    <Row className="justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
      <Col md={6} lg={4}>
        <Card className="p-3">
          <CardHeader className="card_header text-dark d-flex flex-column align-items-center">
            <img src={Logo} alt="ConCredito" className="w-25 h-25" />
            <CardTitle tag="h4" className="text-center">Faça seu Login</CardTitle>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleLogin}>
              <FormGroup>
                <Input
                  type="email"
                  placeholder="Seu email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setEmailError('') }}
                  invalid={!!emailError}
                />
                <FormFeedback>{emailError}</FormFeedback>
              </FormGroup>

              <FormGroup className="position-relative">
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder="Sua senha"
                  value={password}
                  onChange={(e) => { setPassword(e.target.value); setPasswordError('') }}
                  invalid={!!passwordError}
                />
                <span
                  className={(passwordError !== "") ? "d-none" : "position-absolute end-0 top-50 translate-middle-y me-3"}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
                <FormFeedback>{passwordError}</FormFeedback>
              </FormGroup>

              <div className="text-center mb-3">
                <Button color="link" onClick={() => setForgotPasswordModal(true)} style={{ fontSize: '0.875rem' }}>
                  Esqueceu sua senha?
                </Button>
              </div>

              <Row className="justify-content-between">
                <Col>
                  <Button className="button_adjust" color="primary" type="submit" disabled={loading}>
                    {loading ? <Spinner size="sm" /> : "Login"}
                  </Button>
                </Col>
                <Col className="text-end">
                  <Button className="button_clear" color="secondary" onClick={handleClear} disabled={loading}>
                    Limpar
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
          <CardFooter className="card_footer text-dark text-center">
            ConCredito. ©2025
          </CardFooter>
        </Card>
      </Col>

      <Modal isOpen={forgotPasswordModal} toggle={() => setForgotPasswordModal(!forgotPasswordModal)} contentClassName="p-2">
        <ModalHeader toggle={() => setForgotPasswordModal(!forgotPasswordModal)}>
          Recuperar Senha
        </ModalHeader>
        <ModalBody>
          <Input
            type="email"
            placeholder="Digite seu email"
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button className="button_adjust" onClick={handleForgotPassword} disabled={buttonForgotPassword}>
            {buttonForgotPassword ? <Spinner size="sm" /> : "Enviar"}
          </Button>{' '}
          <Button className="button_clear" onClick={() => setForgotPasswordModal(false)}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </Row>
  );
};